import { Sun, Moon } from "@phosphor-icons/react";
import { useTheme } from "../lib/theme";

export default function ThemeToggle({ className = "", variant = "default" }) {
  const { theme, toggleTheme } = useTheme();
  const isLight = theme === "light";
  const base = "inline-flex items-center justify-center gap-1.5 transition-colors";
  const styles = {
    default: `${base} text-xs px-2.5 py-1.5 border border-neutral-300 hover:bg-neutral-100`,
    dark: `${base} text-xs px-2.5 py-1.5 border border-neutral-700 text-neutral-300 hover:bg-[#1a1a1a]`,
    pill: `${base} w-9 h-9 rounded-full bg-neutral-100 hover:bg-neutral-200`,
    minimal: `${base} text-xs px-2 py-1 hover:bg-neutral-100`,
  };
  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`${styles[variant] || styles.default} ${className}`}
      aria-label={isLight ? "Switch to dark mode" : "Switch to light mode"}
      data-testid="theme-toggle"
    >
      {isLight ? <Moon size={16} weight="fill" /> : <Sun size={16} weight="fill" />}
    </button>
  );
}
